import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {Observable} from "rxjs";
import 'rxjs/add/operator/map';

const endpoint = '//api-meteo.bm.pl/rest/devicesHistories/';
const timeRanges: any = {
  live: 'LIVE',
  last_5_minutes: 'LAST_5_MINUTES',
  last_1_hour: 'LAST_1_HOUR',
  last_6_hour: 'LAST_6_HOURS',
  last_12_hour: 'LAST_12_HOURS',
  last_24_hour: 'LAST_24_HOURS'
};
const requestTimeout: number = 5000;

@Injectable()
export class HistoryService {

  constructor(private apiService: ApiService) {
  }

  public getHistory(deviceName: string, timeRange: string = timeRanges.last_6_hour) {
    return this.apiService
      .getFromApi(endpoint + deviceName, {timeRange: timeRange})
      .timeout(requestTimeout)
      .map((res: any) => {
        let response: any = res.json();
        if (!response.chartProbes || !response.chartProbes.length) {
            throw Observable.throw(response);
        } else {
            return response;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/history/history.service.ts